import { setCookieValue } from '@do/seashell/utils';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  ACTIVATION_REDIRECT_COOKIE,
  ACTIVATION_REDIRECT_PARAM
} from '../constants';

/**
 * Checks if there is an "activation_redirect" query param
 * and sets a cookie with its value
 *
 * @returns the value of the query param
 */
const useActivationRedirectCookie = (): string | null => {
  const [searchParams] = useSearchParams();
  const activationRedirectUrl = searchParams.get(ACTIVATION_REDIRECT_PARAM);

  useEffect(() => {
    if (activationRedirectUrl) {
      setCookieValue(ACTIVATION_REDIRECT_COOKIE, activationRedirectUrl);
    }
  }, [activationRedirectUrl]);

  return activationRedirectUrl;
};

export default useActivationRedirectCookie;
